<template>
<div class="gp-content">
  <div class="dashboard-container scroll-vertical">
    <div class="tile is-ancestor">
      <div class="tile is-vertical">

        <div class="tile">
          <div class="tile is-parent">
            <div class="tile is-parent is-danger">
              <div class="tile is-child">
                <chart-line-bar-time-series
                  class="alert-stats-dashboard"
                  endpoint="primary/listAlertsStats"
                  title="Alerts"
                  :filter="filter"
                  height="150px">
                  <p
                    v-for="filt in filters"
                    :key="filt.label"
                    class="level-item is-size-6 filter"
                    :class="{ 'selected': filt.label === filter.label }"
                    @click="filter=filt">
                    {{ filt.label }}
                  </p>
                </chart-line-bar-time-series>
                <value-count-tags
                  class="value-tags"
                  endpoint="primary/listAlertsTags"
                  :filter="filter"
                  v-on:tag-click="alertTagClick($event.tag)"
                ></value-count-tags>
              </div>
            </div>
          </div>
        </div>

        <div class="tile">
          <div class="tile is-parent">
            <div class="tile is-parent is-blue">
              <div class="tile is-child">
                <chart-line-bar-time-series
                  class="log-stats-dashboard"
                  endpoint="primary/listLogsStats"
                  title="Logs"
                  :filter="filter"
                  height="150px">
                    <p
                      v-for="filt in filters"
                      :key="filt.label"
                      class="level-item is-size-6 filter"
                      :class="{ 'selected': filt.label === filter.label }"
                      @click="filter=filt">
                      {{ filt.label }}
                    </p>
                </chart-line-bar-time-series>
                <value-count-tags
                  class="value-tags"
                  endpoint="primary/listLogsTags"
                  :filter="filter"
                  v-on:tag-click="logTagClick($event.tag)"
                ></value-count-tags>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import timefilters from '@/mixins/timefilters';
import ChartLineBarTimeSeries from '@/components/charts/ChartLineBarTimeSeries.vue';
import ValueCountTags from '@/components/ValueCountTags.vue';

export default {
  name: 'DashBoardMain',
  mixins: [timefilters],
  components: {
    ChartLineBarTimeSeries,
    ValueCountTags,
  },
  data() {
    return {
      filter: {
        label: '7 Days',
        since: '6 days',
        interval: 'day',
      },
    };
  },
  computed: { },
  methods: {
    alertTagClick(tag) {
      this.$router.push({ name: 'alerts.index', query: { q: [`tag:${tag}`] } });
    },
    logTagClick(tag) {
      this.$router.push({ name: 'logs.index', query: { q: [`tag:${tag}`] } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';
@import '@/scss/charts.scss';

.value-tags {
  padding: 0 1rem .5rem 1rem;
}

.is-danger, .is-blue {
  border: 2px solid $border-color;
  padding: .2rem;
}

.dashboard-container {
  padding: 1rem;
}

h5 {
  width: 100%;
  text-align: center;
  font-size: 1rem;
}

.empty-profile {
  .vlevel {
    align-items: center;
  }

  p.vlevel-item {
    text-align: center;
    color: whitesmoke;
  }

  svg.svg-fill {
    fill: currentColor;
  }
}

p {
  text-align: center;
  margin-bottom: 0;
}

p.filter {
  padding: .2rem;
  cursor: pointer;
}

p.filter:nth-last-child(2) {
  margin-left: .5rem;
  margin-right: .5rem;
}
</style>
